import { Icon } from "@components/index";
import "./index.scss";

// Unified Dashboard Card Component - Single design for all roles
const DashboardCard = ({
  card,
  data,
  onClick,
  type = "stat", // Keep for backward compatibility but use same design
}) => {
  const isClickable = card.navigateTo || card.isNavigable;

  // Unified value calculation
  let cardValue;
  if (type === "lob") {
    cardValue = data?.count || 0;
  } else if (card.getValue) {
    cardValue = card.getValue(data);
  } else {
    cardValue = data?.count || 0;
  }

  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(card);
    }
  };

  // Get card title and description
  const cardTitle = card.title || card.label;
  const cardDescription = data?.description || null;

  return (
    <div
      className={`dashboard-card home-card-layout dashboard-card--${card.id} ${
        isClickable ? "dashboard-card--clickable" : ""
      }`}
      onClick={isClickable ? handleClick : undefined}
    >
      <div className="dashboard-card__header">
        <div className="dashboard-card__icon">
          <Icon iconName={card.icon} height={32} width={32} />
        </div>
      </div>

      <div className="dashboard-card__content">
        <h4 className="dashboard-card__title">{cardTitle}</h4>
        <p className="dashboard-card__value">{cardValue}</p>

        {cardDescription && (
          <p className="dashboard-card__description">{cardDescription}</p>
        )}

        {/* Breakdown for non-admin cards */}
        {card.breakdown && (
          <div className="dashboard-card__breakdown">
            {card.breakdown.map((item, idx) => (
              <span
                key={idx}
                className={`dashboard-card__breakdown-item dashboard-card__breakdown-item--${item.type}`}
              >
                {item.label}: {item.getValue(data)}
              </span>
            ))}
          </div>
        )}

        {/* Sub-label for additional info */}
        {card.subLabel && card.getSubValue && (
          <p className="dashboard-card__sub-label">
            {card.subLabel}: {card.getSubValue(data)}
          </p>
        )}
      </div>

      {/* Click indicator for navigable cards */}
      {/* {isClickable && (
        <div className="dashboard-card__click-indicator">
          <Icon iconName="home" height={16} width={16} />
        </div>
      )} */}

      {/* More info hover for non-admin cards */}
      {isClickable && card.moreInfoText && (
        <div className="dashboard-card__more-info">
          <span className="dashboard-card__more-info-text">
            {card.moreInfoText}
          </span>
          <Icon
            iconName="home"
            height={16}
            width={16}
            className="dashboard-card__more-info-icon"
          />
        </div>
      )}
    </div>
  );
};

export default DashboardCard;
